import * as React from 'react';
import * as classNames from 'classnames';
import * as CreDtos from "../../../CRE.dtos";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Spinner } from '../../Controls/Spinner';
import * as AboutUsSettingsActionCreators from "../../../actions/aboutUsSettings.actions";
import UploadTemporaryFile from '../../controls/UploadTemporaryFile';
import InlineTextEdit from '../../Controls/InlineTextEdit';


export interface IAboutUsSettingsProps {
    aboutUsSettings: CreDtos.AboutUsSettings;
    load: Function;
    upsert: Function;
    isLoading: boolean;
    isSaving: boolean;
}

interface IAboutUsSettingsState {
    aboutUsSettings: CreDtos.AboutUsSettings;
}

class AboutUsSettings extends React.Component<IAboutUsSettingsProps, IAboutUsSettingsState> {
    constructor(props: IAboutUsSettingsProps) {
        super(props);
        this.state = {
            aboutUsSettings: new CreDtos.AboutUsSettings()
        }
        this.onValueChanged = this.onValueChanged.bind(this);
        this.onSave = this.onSave.bind(this);
    }

    componentDidMount() {
        this.props.load();
    }

    componentDidUpdate(prevProps) {
        if (!this.props.isLoading && prevProps.isLoading) {
            this.setState({ aboutUsSettings: { ...this.props.aboutUsSettings } });
        } else if (!this.props.isSaving && prevProps.isSaving) {
            this.setState({ aboutUsSettings: { ...this.props.aboutUsSettings } });
        }
    }

    onValueChanged(fieldName: string, value: any) {
        var aboutUsSettings = { ...this.state.aboutUsSettings };
        aboutUsSettings[fieldName] = value;
        this.setState({ aboutUsSettings });
        
    }

    onSave() {
       this.props.upsert(this.state.aboutUsSettings);
    }

    render() {
        let content;

        if (this.props.isLoading) {
            content = (
                <Spinner isOpen={this.props.isLoading} />
            );
        } else if (this.props.isSaving) {
            content = (
                <Spinner isOpen={this.props.isSaving} label="Saving" />
            );
        } else if (this.state.aboutUsSettings) {
            content = (
                <div className="card lightgrey-bg">
                    <div className="card-block">
                        <div className="row">
                            <div className="col-12">
                                <div className="row">
                                    <div className="col-12 mb-1 ">
                                        <strong>Our Mission</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>HTML Content</label>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <InlineTextEdit source={this.state.aboutUsSettings.missionHtmlText} onChange={value => this.onValueChanged("missionHtmlText", value)} />
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <strong>Our Logo</strong>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <label>HTML Content</label>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-1 ">
                                        <div className="mb-0 form-group">
                                            <InlineTextEdit source={this.state.aboutUsSettings.logoHtmlText} onChange={value => this.onValueChanged("logoHtmlText", value)} />
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <p></p>
                                    </div>
                                    <div className="col-12">
                                        <div className="pull-right">
                                            <button type="reset" className="btn btn-primary mr-2" disabled={this.props.isSaving} onClick={() => this.props.load()}>CANCEL</button>
                                            <button type="button" className="btn btn-primary" disabled={this.props.isSaving} onClick={() => this.onSave()}>SAVE</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            <div>
                {content}
            </div>
        );

    }
}


const mapStateToProps = (state, ownProps) => {
    return {
        aboutUsSettings: state.aboutUsSettings.aboutUsSettings,
        isLoading: state.aboutUsSettings.isLoading,
        isSaving: state.aboutUsSettings.isSaving
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
        {
            load: AboutUsSettingsActionCreators.aboutUsSettingsRequest,
            upsert: AboutUsSettingsActionCreators.aboutUsSettingsUpsertRequest
        },
        dispatch
    );
};


const AboutUsSettingsContainer = connect(mapStateToProps, mapDispatchToProps)(
    AboutUsSettings
);

export default AboutUsSettingsContainer;


// WEBPACK FOOTER //
// ./src/components/Administration/AboutUs/AboutUsSettings.tsx